import { useState } from 'react';
import api from '../lib/api';
import { useAuth } from '../hooks/useAuth';

export default function BulkBacklinkPage() {
  const [domains, setDomains] = useState('');
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const { updateCredits } = useAuth();

  async function analyze() {
    const list = domains.split('\n').map(d=>d.trim()).filter(Boolean);
    if (list.length === 0) { setError('Enter domains'); return; }
    if (list.length > 10) { setError('Max 10 domains'); return; }
    setError(''); setLoading(true); setData(null);
    try {
      const res = await api.post('/backlinks/bulk', { domains: list });
      setData(res.data.data);
      updateCredits(res.data.credits_remaining);
    } catch (e) { setError(e.response?.data?.error || 'Failed'); } finally { setLoading(false); }
  }

  return (
    <div className="fade-up">
      <div className="page-header">
        <h1 className="page-title">Bulk Backlink Analysis</h1>
        <p className="page-sub">Check authority, backlinks, ref domains for up to 10 domains · 3 credits per domain</p>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <div style={{ marginBottom: 10 }}>
          <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', color: '#6B7280', marginBottom: 6 }}>Domains (one per line, max 10)</div>
          <textarea className="input" style={{ minHeight: 140 }} placeholder={"semrush.com\nahrefs.com\nmoz.com\nmajestic.com"} value={domains} onChange={e=>setDomains(e.target.value)} />
        </div>
        <button className="btn btn-orange" onClick={analyze} disabled={loading}>{loading ? 'Analyzing...' : 'Analyze →'}</button>
        {error && <div style={{ marginTop: 10, color: '#FF3D57', fontSize: 13, background: '#FFEBEE', padding: '8px 12px', borderRadius: 6 }}>{error}</div>}
      </div>

      {loading && <div className="card"><div className="skeleton" style={{ height: 200 }} /></div>}

      {data && (
        <div className="card">
          <div className="card-header"><span className="card-title">{data.length} domains analyzed</span></div>
          <div className="table-wrap">
            <table className="table">
              <thead><tr><th>Domain</th><th>Authority</th><th>Backlinks</th><th>Ref Domains</th><th>Toxic %</th></tr></thead>
              <tbody>
                {data.map((d,i) => (
                  <tr key={i}><td style={{ fontWeight: 600 }}>{d.domain}</td><td><span className={`badge ${d.authorityScore>70?'badge-green':d.authorityScore>40?'badge-yellow':'badge-red'}`}>{d.authorityScore}</span></td><td>{d.backlinks.toLocaleString()}</td><td>{d.refDomains.toLocaleString()}</td><td>{d.toxicScore}%</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
